import { defineMessages } from 'react-intl';

export const evidencePostUpgradeOnboardingMessages = defineMessages({
  screenReaderTitle: {
    defaultMessage: 'Evidence onboarding',
    id: 'Mkiw17u3me',
    description: 'Accessible dialog title for the post-upgrade Evidence onboarding modal',
  },
  step1Title: {
    defaultMessage: 'See Evidence in action',
    id: 'DXo2+eqOjN',
    description: 'Heading for step 1 of post-upgrade Evidence onboarding',
  },
  step1Body: {
    defaultMessage:
      'Watch how Dr Ben Condon gets clinical answers using trusted sources.',
    id: 'zFfpET6Rpw',
    description: 'Body copy for step 1 of post-upgrade Evidence onboarding',
  },
  step2Title: {
    defaultMessage: 'Clear outputs, ready to share',
    id: 'XVIb1dZnov',
    description: 'Heading for step 2 of post-upgrade Evidence onboarding',
  },
  step2Body: {
    defaultMessage:
      'Evidence-backed explainers, handouts and care plans without leaving your session.',
    id: '2VL11kNGHZ',
    description: 'Body copy for step 2 of post-upgrade Evidence onboarding',
  },
  step3Title: {
    defaultMessage: 'Work from sources you trust',
    id: 'z8pjtln3za',
    description: 'Heading for step 3 of post-upgrade Evidence onboarding',
  },
  step3Body: {
    defaultMessage:
      'Guidelines, journals and your own curated library shape every answer Evidence gives.',
    id: 'D3ZR6gSWxn',
    description: 'Body copy for step 3 of post-upgrade Evidence onboarding',
  },
  next: {
    defaultMessage: 'Next',
    id: 'gH5vi2ePRT',
    description: 'Primary button to advance onboarding steps 1–2',
  },
  viewGuide: {
    defaultMessage: 'View guide',
    id: 'bT1pqMAO8e',
    description: 'Secondary link-style CTA opening the help centre (step 1)',
  },
  learnMore: {
    defaultMessage: 'Learn more',
    id: 'rrFk7I99uZ',
    description: 'Secondary link-style CTA opening the help centre (step 2)',
  },
  gotIt: {
    defaultMessage: 'Got it',
    id: 'e1yO3XSfwp',
    description: 'Primary button to dismiss onboarding on the final step',
  },
  tryNow: {
    defaultMessage: 'Try now',
    id: 'uvz/aZg88d',
    description: 'Secondary CTA to open Evidence chat from the final onboarding step',
  },
  stepProgress: {
    defaultMessage: 'Step {current} of {total}',
    id: '3uSL6LFiPh',
    description: 'Step indicator under onboarding buttons',
  },
  videoTitle: {
    defaultMessage: 'Evidence walkthrough video',
    id: 'jmTDB7JkcG',
    description: 'Accessible title for the embedded Loom player in onboarding step 1',
  },
});
